import { GET_KYC_INFO_REQUEST, GET_KYC_INFO_SUCCESS, GET_KYC_INFO_FAILURE, GET_KYC_INFO_RESET, } from "../../actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const getKycInfoReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_KYC_INFO_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case GET_KYC_INFO_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        case GET_KYC_INFO_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload, data: null });
        case GET_KYC_INFO_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, data: null, error: null });
        default:
            return state;
    }
};
export default getKycInfoReducer;
